import { Box, Grid, IconButton, TextField } from "@mui/material";
import { useState } from "react";
import { ApiError, ApiErrorClass } from "@readyfit-common/models";
import { handleApiError } from "@readyfit-common/utils";
import { AttachmentIcon, SendIcon } from "src/grading/assets";
import { useAppDispatch } from "src/store/hooks";
import { useSendChatMessageMutation, useSendGroupChatMessageMutation } from "src/store/reducers/training/trainingApiSlice";
import useStyles from "./MessageInput.styles";

interface MessageInputProps {
  athleteId?: string;
  isGroupChat?: boolean;
  groupChatId?: string;
}

export default function MessageInput({ athleteId, isGroupChat, groupChatId }: MessageInputProps) {
  const classes = useStyles();
  const [sendChatMessage, { isLoading: isSending }] =
    useSendChatMessageMutation();
  const [sendGroupChatMessage, { isLoading: isSendingGroup }] =
    useSendGroupChatMessageMutation();
  const dispatch = useAppDispatch();
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      if (isGroupChat) {
        if (!groupChatId) throw new ApiErrorClass({ message: "Group chat ID is required" });
        await sendGroupChatMessage({ groupChatId, message }).unwrap();
      } else {
        if (!athleteId) throw new ApiErrorClass({ message: "Athlete ID is required" });
        await sendChatMessage({ athleteId, message }).unwrap();
      }
      setMessage("");
    } catch (error) {
      handleApiError(dispatch, error as ApiError);
    }
  };

  return (
    <Box>
      <Grid
        container
        spacing={1}
        alignItems="center"
        component="form"
        onSubmit={handleSubmit}
      >
        <Grid item>
          <IconButton className={classes.iconContainer}>
            <AttachmentIcon />
          </IconButton>
        </Grid>
        <Grid item xs>
          <TextField
            fullWidth
            name="message"
            placeholder="Text"
            variant="outlined"
            size="medium"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </Grid>
        <Grid item>
          <IconButton
            className={classes.iconContainer}
            type="submit"
            disabled={isSending || isSendingGroup}
          >
            <SendIcon />
          </IconButton>
        </Grid>
      </Grid>
    </Box>
  );
}
